import { FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const NotFoundPage: FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/')
    }, 1000)

    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <>
      <br />
      <br />
      <br />
      {'Nieco sa pokazilo :('}
    </>
  )
}
